import { MapPin, ArrowUpRight } from "lucide-react";
import { Reveal, Eyebrow } from "./primitives";
import { DIRECTORY } from "@/lib/content";

export default function Directory() {
  return (
    <section id="directory" data-testid="directory-section" className="bg-bone py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="flex flex-col gap-6 sm:flex-row sm:items-end sm:justify-between">
          <Reveal className="max-w-2xl">
            <Eyebrow>{DIRECTORY.eyebrow}</Eyebrow>
            <h2 className="mt-6 font-serif text-4xl font-medium leading-tight tracking-tight text-ink sm:text-5xl">
              {DIRECTORY.heading}
            </h2>
            <p className="mt-6 text-base leading-relaxed text-stone sm:text-lg">{DIRECTORY.intro}</p>
          </Reveal>
        </div>

        <div className="mt-14 grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
          {DIRECTORY.centers.map((c, i) => (
            <Reveal key={c.name} delay={(i % 3) * 0.08}>
              <article
                data-testid={`center-card-${i}`}
                className="group flex h-full flex-col overflow-hidden rounded-3xl bg-sand transition-all duration-500 hover:-translate-y-1.5 hover:shadow-[0_24px_60px_rgba(45,48,42,0.12)]"
              >
                <div className="relative aspect-[4/3] overflow-hidden">
                  <img
                    src={c.image}
                    alt={c.name}
                    className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
                  />
                  <span className="absolute left-4 top-4 rounded-full bg-bone/90 px-3 py-1 text-xs font-bold uppercase tracking-[0.15em] text-ink backdrop-blur">
                    {c.type}
                  </span>
                </div>
                <div className="flex flex-1 flex-col p-7">
                  <div className="flex items-center gap-2 text-sm text-sage">
                    <MapPin className="h-4 w-4" strokeWidth={2.2} />
                    {c.location}
                  </div>
                  <h3 className="mt-3 font-serif text-2xl font-medium text-ink">{c.name}</h3>
                  <p className="mt-2 flex-1 text-sm leading-relaxed text-stone">{c.body}</p>
                  <span className="mt-6 inline-flex items-center gap-1.5 text-sm font-semibold text-terracotta">
                    Learn more
                    <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
                  </span>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
